import { useIntl } from 'react-intl';

export const useSessionStatusMap = () => {
  const intl = useIntl();

  const sessionStatus: { [key: string]: string } = {
    eu_no_show: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.USERNOSHOW.STATUS',
    }),
    eu_early_cancel: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.USEREARLYCANCEL.STATUS',
    }),
    eu_late_cancel: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.USERLATECANCEL.STATUS',
    }),
    completed: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.COMPLETED.STATUS',
    }),
    cp_no_show: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.NOSHOWTHERAPIST.STATUS',
    }),
    cp_late_cancel: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.LATECANCELTHERAPIST.STATUS',
    }),
    no_show: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.MUTUALNOSHOW.STATUS',
    }),
    incomplete: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.INCOMPLETE.STATUS',
    }),
    confirmed: intl.formatMessage({
      id: 'SESSION.HISTORY.CP.CONFIRMED.STATUS',
    }),
  };

  const sessionStatusMap = (status: string) => {
    return sessionStatus[status];
  };

  return sessionStatusMap;
};
